module.exports = __webpack_public_path__ + "img/public/AdminIcons/changePassword.svg?14692a2b";